import { Skeleton } from "@mui/material";
import { useSelector } from "react-redux";

export const formatStatsCount = (value) => {
  if (value === null || value === undefined || value === "") return "0";
  if (typeof value === "object") {
    return (
      value.name ||
      value.title ||
      value.soundTitle ||
      value.categoryName ||
      value.fullName ||
      "-"
    );
  }
  return value;
};

const StatsCards = ({
  cards = [],
  colClass = "col-xl-3 col-sm-6 col-12",
  loading,
}) => {
  const { isLoading } = useSelector((state) => state.dialogue);
  // Avoid skeleton flicker when table/filter GET sets global isLoading
  // but stats data is already available (or parent controls loading explicitly).
  const hasStatsData = cards.some(
    (card) => card.count !== null && card.count !== undefined
  );
  const showSkeleton =
    loading !== undefined ? loading : isLoading && !hasStatsData;

  if (!cards?.length) return null;

  return (
    <div className="dashBoardMain px-2 mb-2">
      <div className="row dashboard-count-box">
        {cards.map((card, index) => (
          <div className={colClass} key={card.title || index}>
            <div className="card">
              {showSkeleton ? (
                <Skeleton
                  variant="square"
                  width="100%"
                  height="135px"
                  style={{ borderRadius: "15px" }}
                />
              ) : (
                <div className="card-content">
                  <div className="card-body p-4">
                    <div className="align-content-center d-flex justify-content-between media">
                      <div className="media-body text-left">
                        <h3 className="warning">
                          {formatStatsCount(card.count)}
                        </h3>
                        <span className="fw-medium">{card.title}</span>
                      </div>
                      <div className="align-self-center">
                        {card.Icon ? (
                          <card.Icon className="dashboard-card-icon" />
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsCards;
